export const ADMIN_MENUS = [
  { path: "/dashboard", name: "工作台", icon: "el-icon-s-home" },
  { path: "/user/list", name: "用户列表", icon: "el-icon-user" },
  { path: "/user/friends", name: "好友关系", icon: "el-icon-connection" },
  { path: "/user/deactivated", name: "注销用户", icon: "el-icon-remove-outline" },
  { path: "/user/login-logs", name: "登录日志", icon: "el-icon-document" },
  { path: "/user/bans", name: "IP/设备黑名单", icon: "el-icon-lock" },
  { path: "/user/freeze", name: "冻结管理", icon: "el-icon-warning-outline" },
  { path: "/user/reg-config", name: "注册设置", icon: "el-icon-setting" },
  { path: "/user/sms-logs", name: "短信记录", icon: "el-icon-message" },
  { path: "/user/client-roles", name: "端内角色", icon: "el-icon-user-solid" },
  { path: "/group/list", name: "群组", icon: "el-icon-s-custom" },
  { path: "/group/default-config", name: "群默认设置", icon: "el-icon-setting" },
  { path: "/message/list", name: "消息记录", icon: "el-icon-chat-line-square" },
  { path: "/av/calls", name: "通话记录", icon: "el-icon-phone" },
  { path: "/security/report", name: "举报处理", icon: "el-icon-s-flag" },
  { path: "/security/sensitive", name: "敏感词", icon: "el-icon-warning-outline" },
  { path: "/wallet/kyc", name: "实名审核", icon: "el-icon-postcard" },
  { path: "/wallet/withdrawals", name: "提现审核", icon: "el-icon-s-finance" },
  { path: "/wallet/banks", name: "银行字典", icon: "el-icon-office-building" },
  { path: "/wallet/recharge-orders", name: "充值工单", icon: "el-icon-tickets" },
  { path: "/wallet/flows", name: "账变流水", icon: "el-icon-s-order" },
  { path: "/wallet/transfers", name: "转账记录", icon: "el-icon-sort" },
  { path: "/redpacket/records", name: "红包记录", icon: "el-icon-s-finance" },
  { path: "/wallet/recharge", name: "后台充值", icon: "el-icon-wallet" },
  { path: "/wallet/approvals", name: "资金复核", icon: "el-icon-s-check" },
  { path: "/wallet/bill-report", name: "账单报表", icon: "el-icon-data-analysis" },
  { path: "/redpacket/config", name: "红包规则", icon: "el-icon-present" },
  { path: "/redpacket/group-settings", name: "群红包权限", icon: "el-icon-s-ticket" },
  { path: "/wallet/checkin", name: "签到规则", icon: "el-icon-date" },
  { path: "/operation/announcements", name: "系统公告", icon: "el-icon-bell" },
  { path: "/operation/explore", name: "探索", icon: "el-icon-s-opportunity" },
  { path: "/operation/emojis", name: "表情", icon: "el-icon-picture" },
  { path: "/av/config", name: "音视频渠道", icon: "el-icon-phone-outline" },
  { path: "/system/site", name: "站点与安全", icon: "el-icon-setting" },
  { path: "/system/account", name: "管理员", icon: "el-icon-s-custom" },
  { path: "/system/role", name: "后台角色", icon: "el-icon-s-check" },
  { path: "/system/menu", name: "菜单管理", icon: "el-icon-menu" },
  { path: "/system/audit", name: "操作审计", icon: "el-icon-document" },
  { path: "/system/exports", name: "下载中心", icon: "el-icon-download" },
  { path: "/system/admin-login-logs", name: "后台登录日志", icon: "el-icon-document" },
];

export const ADMIN_PERMISSIONS = [
  "dashboard:view",
  "user:view",
  "user:ban",
  "user:kick",
  "user:edit",
  "user:official",
  "user:whitelist",
  "user:adjust",
  "user:login_log",
  "ban:view",
  "ban:edit",
  "freeze:view",
  "freeze:edit",
  "reg:view",
  "reg:edit",
  "client_role:view",
  "client_role:edit",
  "friend:view",
  "friend:edit",
  "group:view",
  "group:edit",
  "group:member",
  "message:view",
  "message:recall",
  "message:wipe",
  "sensitive:view",
  "sensitive:edit",
  "report:view",
  "report:handle",
  "redpacket:view",
  "redpacket:edit",
  "av:view",
  "av:edit",
  "wallet:recharge",
  "wallet:view",
  "transfer:view",
  "transfer:edit",
  "checkin:view",
  "checkin:edit",
  "recharge_order:view",
  "recharge_order:review",
  "announce:view",
  "announce:edit",
  "explore:view",
  "explore:edit",
  "emoji:view",
  "emoji:edit",
  "site:view",
  "site:edit",
  "group_config:view",
  "group_config:edit",
  "bill:view",
  "kyc:view",
  "kyc:review",
  "kyc:view_sensitive",
  "withdraw:view",
  "withdraw:review",
  "withdraw:view_sensitive",
  "bank:view",
  "bank:edit",
  "audit:view",
  "rbac:view",
  "rbac:edit",
  "admin:view",
  "admin:edit",
  "role:view",
  "role:edit",
  "role:menu",
  "menu:view",
  "menu:edit",
];

function normalizeUserInfo(data) {
  if (data.userInfo && typeof data.userInfo === "object") {
    return {
      id: data.userInfo.id || data.admin_id,
      username: data.userInfo.username || data.username,
      nickname: data.userInfo.nickname || data.nickname || data.username,
      role: data.userInfo.role || "admin",
    };
  }
  return {
    id: data.admin_id,
    username: data.username,
    nickname: data.nickname || data.username,
    role: "admin",
  };
}

function normalizeMenus(data) {
  if (Array.isArray(data.menus) && data.menus.length) {
    return data.menus;
  }
  return ADMIN_MENUS;
}

function normalizePermissions(data) {
  if (Array.isArray(data.permissions) && data.permissions.length) {
    return data.permissions;
  }
  return ADMIN_PERMISSIONS;
}

export function mapLoginResponse(data) {
  return {
    token: data.token,
    userInfo: normalizeUserInfo(data),
    menus: normalizeMenus(data),
    permissions: normalizePermissions(data),
  };
}

export function mapProfileResponse(data) {
  return {
    userInfo: normalizeUserInfo(data),
    menus: normalizeMenus(data),
    permissions: normalizePermissions(data),
  };
}
